import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './versedetails.css'

function VerseDetails() {
  let navigate  = useNavigate();
  const { chapter_id, id } = useParams();
  const [verse, setVerse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVerse = async () => {
      const response = await fetch('https://bhagavad-gita3.p.rapidapi.com/v2/chapters/' + chapter_id + '/verses/' + id + '/', {
        "method": "GET",
        "headers": {
          "content-type": "application/json",
          "x-rapidapi-host": "bhagavad-gita3.p.rapidapi.com",
          "x-rapidapi-key": "4034969b2cmshf9e4ab0b6a68552p1e99cajsn6474fa44b7c4"
        }
      });
      const data = await response.json();
      setVerse(data);
      setIsLoading(false);
    };
    fetchVerse();
  }, [chapter_id, id]);

  return (
    <div className='verse'>
      {isLoading ? (
        <div class="d-flex justify-content-center center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      ) : (
        <div className='verse-container'>
          <div className="card mb-3">
            <img src='https://www.bhagavad-gita.us/wp-content/uploads/2012/10/gita-02.jpg' className="card-img-top" alt="..."/>
            <div className="card-body">
              <h5 className="card-title">{verse.text}</h5>
              <button className='back-btn' onClick={() => navigate(-1)}><i className="fa-solid fa-arrow-left"></i><span>Back</span></button>
              <hr></hr>
              
              <h4 className='tr-title'>Translations:</h4>
              
              {verse.translations?.map(translation => (
                translation.language === 'hindi' && (
                  <div key={translation.id}>
                    <div className='hindi-container'>
                      <h3 className='author-title'>{translation.author_name}</h3>
                      <h5 className='hindi-des'>{translation.description}</h5>
                    </div>
                  </div>
                )
              ))}
              
              {verse.translations?.map(translation => (
                translation.language === 'english' && (
                  <div key={translation.id}>
                    <div className='english-container'>
                      <h3 className='author-title'>{translation.author_name}</h3>
                      <h5 className='english-des'>{translation.description}</h5>
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VerseDetails;